// ============================================================================
// Voice / Interview Data
// ============================================================================

export type VoiceVideo = {
  id: string;
  slug: string;
  title: string;
  before: string;
  reason: string;
};

export type VoiceInterview = {
  slug: string;
  title: string;
  excerpt: string;
  date: string;
  thumbnail?: string;
  profile: {
    name: string;
    age: string;
    background: string;
  };
  videoId?: string;
  noteId?: string;
  takeaways?: string[];
  content: {
    question: string;
    answer: string;
  }[];
};

// ============================================================================
// 動画データ（Vimeo）
// ============================================================================

export const voiceVideos: VoiceVideo[] = [
  {
    id: "1163288065",
    slug: "asami-27-it-beginner",
    title: "あさみさん 27歳 IT未経験",
    before: "ITとは無縁の仕事。将来への漠然とした不安を抱えていた",
    reason: "18ヶ月かけてじっくり学べるというところに惹かれた",
  },
  {
    id: "1155472986",
    slug: "a-san-23-teacher",
    title: "23歳 私立教員 未経験",
    before: "教員として働く中で「手に職をつけたい」と感じていた",
    reason: "すぐに質問できて悩みを解決できる環境に魅力を感じた",
  },
  {
    id: "1155686191",
    slug: "miyazaki-27-freeter",
    title: "宮崎さん 27歳 フリーター 未経験",
    before: "過去に別のスクールに通ったが、スキルが身につかなかった",
    reason: "現役エンジニアの講師陣のレベルが高く、信頼できると感じた",
  },
  {
    id: "1159471067",
    slug: "25-it-worker",
    title: "25歳 IT職",
    before: "フリーランスも視野に入れており、スキルアップが必要だった",
    reason:
      "カウンセリングで「ただコードが書けるだけじゃ意味がない」という言葉に共感した",
  },
  {
    id: "1164598984",
    slug: "nabechan-30s-mama",
    title: "なべちゃんさん 30代 技術開発職 2児の母 未経験",
    before: "二児の子育て中。今後在宅でできる仕事がしたいと思っていた",
    reason:
      "学習期間が長く、ロードマップも広く体系的に学べるところに惹かれた",
  },
  {
    id: "1185117557",
    slug: "freelance-designer-challenge",
    title: "フリーランスデザイナー 主婦",
    before: "LINE関連のデザイン業務をしていたが、単価アップのためにプログラミングを学びたかった",
    reason: "講座内容が網羅的で、サポート期間が長く自分のペースで進められると感じた",
  },
];

// ============================================================================
// インタビュー記事データ
// ============================================================================

export const voiceInterviews: VoiceInterview[] = [
  {
    slug: "teacher-to-frontend-engineer",
    title:
      "教員1年目が選んだ「手に職」への第一歩｜あいねさん 23歳 私立教員",
    excerpt:
      "新卒で教員になったものの、将来の不透明さを感じてプログラミング学習を決意。チャットで質問し放題（回答は24時間以内）と1on1面談 月1回（最大12回）で着実に成長中。",
    date: "2026-03-11",
    profile: {
      name: "あいねさん",
      age: "23歳",
      background: "私立学校教員",
    },
    videoId: "1155472986",
    noteId: "n1eaadca066e7",
    takeaways: [
      "教員1年目、将来の不安から「手に職」としてプログラミング学習を開始",
      "チャットで質問し放題（回答は24時間以内）と1on1面談 月1回（最大12回）が継続の支えに",
      "学習ポータルで進捗・宿題の期限を可視化し、自分のペースで学習中",
      "フロントエンド＋デザインを組み合わせたキャリアを模索中",
    ],
    content: [
      {
        question: "簡単に自己紹介をお願いいたします。",
        answer:
          "地方で私立学校の教員をしております。趣味はドラムを叩くことと、あと料理をすることが好きです。23歳です。よろしくお願いします。",
      },
      {
        question:
          "プログラミングやAIなどに興味を持ったのはいつ頃、どんなきっかけですか？",
        answer:
          "興味を持ち始めたのは大体半年ぐらい前からで、新卒で仕事を始めたはいいものの、やっぱりちょっと==未来のこの時代の不確定さを考えると、もっといろんなスキルを身につけたいな==っていう思いが強くなってきて。そこから少しプログラミングに興味を持ち始めました。",
      },
      {
        question: "学ぶ上でどんなことを理想としていましたか？",
        answer:
          "私はなかなか一人じゃ進もうと思っても進められないっていう、ちょっと弱さがあるので。==一緒に頑張ってくれる人がいたら、ちょっと学びやすいかな==っていう理想像はありました。",
      },
      {
        question: "入会前、どんなことで悩んでいましたか？",
        answer:
          "私はちょっと先ほどもお話ししたんですけど、自分で何かを継続するということがすごく苦手だったので。ここで、お金を払ってスクールに入ったとして、本当に続けられるのかなっていうところが一番不安な要素でした。",
      },
      {
        question:
          "他の学習サービスやスクールと比較して、なぜゆめさくエンジニアを選ばれたんですか？",
        answer:
          "ゆめさくエンジニアさんで一番いいなと思ったのは、==すぐに質問をチャットで答えてくれる点==と、==1ヶ月ごとにワンオンワンで悩みや今後の道のりを一緒に考えてくれる==っていうところをすごく魅力に感じました。",
      },
      {
        question:
          "実際に受講してみて一番印象に残っていることは何ですか？",
        answer:
          "受講生が集まる部屋みたいなのがあって、そこで何でも質問ができたりとか、自己紹介をし合ったりとか。そこで==一緒に頑張っている仲間がいるんだな==っていうのがすごく心強いです。",
      },
      {
        question:
          "受講に関して、難しさや分かりやすさについてはどう感じましたか？",
        answer:
          "==初心者でもすごく分かりやすい言葉で説明されている==ので、基本的にはスライドを見て、自分で確認テストなどを答えることで進めていくことができています。たまに分からない単語もあるのですが、そこについては==すぐ質問をすると答えてくれます==ので、安心して今のところ進められています。",
      },
      {
        question:
          "特に良かったコンテンツとかサポートはありましたか？",
        answer:
          "学習ポータルサイトというサイトがあって、そこで今の自分が大体どれぐらいカリキュラムを進められているかとか、あとは自分の宿題が、あと何個溜まっていて期限がどれぐらいあるかっていうのを==一目でみることができる==ので。なかなか継続が苦手な私でも「もうあとちょっと、今日はここまで頑張ろう」とか「今週はここまで頑張ろう」っていう==目標を立てやすくて==。そのおかげで続けられているなと思います。",
      },
      {
        question:
          "スキル面やマインド面で、入会前と比べてどんな変化がありましたか？",
        answer:
          "入会前は「本当に未経験の私でもできるかな」っていうところが本当に心配で悩んだ要素の一つではあったんですけど。今のところちょこちょこ隙間時間でも進めることができているので、あとは==18ヶ月しっかり乗り切って、エンジニアになってやろう==っていう強い気持ちがあります。",
      },
      {
        question:
          "ポートフォリオ制作、副業、転職など、何か動きはありましたか？",
        answer:
          "まだ1ヶ月も経っていないので、今はカリキュラムと宿題を少しずつこなしているという状況なんですけど。徐々に転職サイトや、実際にどういうお仕事があるかなどは直近で見始めたいなと思っております。",
      },
      {
        question: "今後学んだスキルをどう活かしていきたいですか？",
        answer:
          "私は今、デザインの方も勉強していて、この間講義の中で「フロントエンド」というものがあるよっていうのを教えていただいたので。エンジニアとしての知識と、あとはちょっと学んだデザインの面も活かしながら、エンジニアとして活動していけたらいいなと思っております。",
      },
      {
        question:
          "フリーランス、転職、副業など、どんな働き方やキャリアを目指されていますか？",
        answer:
          "最初は副業から始めて、徐々に自信がついていったらゆくゆくは独立して、フリーランスとして働いていきたいなと思っています。",
      },
      {
        question:
          "これから始める人に一言メッセージをお願いいたします。",
        answer:
          "入会前、すごく迷うことも本当に多いとは思うんですけど。ここなら絶対に、==一緒に頑張ってくれる人たちがいるので続けることができる==と、自信を持っておすすめすることができます。ぜひ一緒に頑張ってくれる仲間が増えたら嬉しいです。",
      },
    ],
  },
  {
    slug: "miyazaki-freeter-to-engineer",
    title:
      "フリーターからエンジニア転職への挑戦｜宮崎さん 27歳",
    excerpt:
      "別のスクールで講師の質にばらつきを感じていた宮崎さん。「講師の質に自信がある」という代表の言葉に惹かれ入会。週2回のライブ授業と仲間の存在を支えに、フロントエンドエンジニアを目指す。",
    date: "2026-03-11",
    profile: {
      name: "宮崎さん",
      age: "27歳",
      background: "フリーター",
    },
    videoId: "1155686191",
    noteId: "n9d2bcdf15b48",
    takeaways: [
      "別のスクールで講師の質にばらつきを感じ、スクール選びに悩んでいた",
      "代表の「講師の質には自信がある」という言葉が入会の決め手",
      "週2回のライブ授業と受講生コミュニティが学習のモチベーションに",
      "フロントエンドエンジニアとしての就職を目標に学習中",
    ],
    content: [
      {
        question: "簡単に自己紹介をお願いいたします。",
        answer:
          "宮崎と申します。今はフリーターで、アルバイトをしながら勉強しております。",
      },
      {
        question:
          "プログラミングやAIなどに興味を持たれたのはいつ頃、どんなきっかけですか？",
        answer:
          "興味を持ったのは本当に最近で、2年前とかなんですけれども。たまたま携帯のアプリ一覧とか見ていた時に、自分もこういうアプリを作れたらいいなと思ったのがきっかけです。",
      },
      {
        question: "学ぶ上でどんなことを理想としていましたか？",
        answer:
          "もともと、今もフリーターで働いているんですけれども、ゆくゆくは転職してエンジニアとして働いていけたらいいなと思ってます。",
      },
      {
        question: "入会前、どんなことで悩んでいましたか？",
        answer:
          "まずはオンラインスクールがとてつもなく多いっていうところで、何から始めたらいいのか分からないっていうのと、何を揃えたらいいのか分からないのと、情報が多いのでどのように選んだらいいのか分かんないっていうところが、とても不安でした。",
      },
      {
        question:
          "他の学習サービスやスクールと比較して、なぜゆめさくエンジニアを選ばれたんですか？",
        answer:
          "もともと別のスクールの方でプログラミングを学んではいたんですけれども、受講者の数がとてつもなく多くって。講師の先生に聞ける回数と分数も1日に15分という風に限られている中で、いろんな講師の先生がいらしたんですけど、==講師の方の質にばらつきがある==なと思って。その際に、こちらの代表の方の説明を聞いて、==「講師の質には自信があります」==っていうのを自信満々におっしゃっていたので、入会をしました。",
      },
      {
        question:
          "実際に受講してみて一番印象に残っていることは何ですか？",
        answer:
          "まだ自分自身が一期生なので、他の方と関わったとかっていうのは本当にないんですけれども。やっぱり、==週2回開催されてるZoomの勉強会==が今はとてつもなく印象に残ってます。ありがたいです。",
      },
      {
        question:
          "難しさや分かりやすさについてはどう感じましたか？",
        answer:
          "自分自身ちょっとまだ進むスピードが遅くて、先の方まで進められてないのはあるんですけれども。分かりやすく噛み砕いてカリキュラムにしてくださってるので、今のところはやりやすいです。",
      },
      {
        question:
          "特に良かったコンテンツやサポートはありましたか？",
        answer:
          "「テラス（Terrace）」っていうアプリで、自分が入ってたら他の受講生の方もたまに入ってる時があるので。==「一緒に勉強しているんだな」==っていうところが、一緒に頑張れそうっていう感じでいいなって思ってます。",
      },
      {
        question: "今後学んだスキルをどう活かしていきたいですか？",
        answer:
          "自分の目標としてはフロントエンジニアとして活躍することなので。就職してエンジニアになって、自分の理想の人物像に近づけたらいいなと考えております。",
      },
      {
        question:
          "これから始める人に一言メッセージをお願いいたします。",
        answer:
          "プログラミングを学ぶにあたって、とてつもなく大きな一歩を踏み出すと思うんですけれども。いろんなところの話を聞いて、==自分に合っているところを選んでもらって==、もしよかったら一緒に勉強して夢を叶えましょう。",
      },
    ],
  },
  {
    slug: "it-engineer-freelance-fullstack",
    title:
      "「ただコードが書けるだけじゃ意味がない」に共感｜25歳 IT企業エンジニア",
    excerpt:
      "IT企業3年目の現役エンジニア。スクール選びで悩んだ「できる」のレベル感。カウンセリングでの一言に共感し入会。副業→フリーランス独立を見据え、フロントもバックエンドもできるエンジニアを目指す。",
    date: "2026-03-11",
    profile: {
      name: "ユウキさん",
      age: "25歳",
      background: "IT企業エンジニア（3年目）",
    },
    videoId: "1159471067",
    takeaways: [
      "IT企業3年目、「できる」のレベル感がスクール選びの最大の悩みだった",
      "カウンセリングの「ただコードが書けるだけじゃ意味がない」に共感し入会",
      "現職のバックエンド経験＋スクールでフロントを学び、副業→フリーランスを計画",
      "カリキュラムの現実的なキャリア教育に実務経験者としても学びがあると実感",
    ],
    content: [
      {
        question: "簡単に自己紹介をお願いいたします。",
        answer:
          "IT企業の方でエンジニアとして働いております。今、社会人歴としては3年目になります。",
      },
      {
        question:
          "プログラミングやAIなどに興味を持ったのは、いつ頃どんなきっかけからですか？",
        answer:
          "大学時代に必修科目としてHTMLとCSSを学んだ時に、エラー引っかかっても面白いな、楽しいなと思ってたので、プログラミングに対してはそこで興味を持ちました。AIの方は、IT企業の方に入社して、AIが嘘つくのも楽しんでとかっていうのをすごい教えてくれてた時があったので。AIに対する恐怖心もありつつ、面白いものなんだなっていうのを思いましたね。",
      },
      {
        question: "入会前、どんなところで悩んでいましたか？",
        answer:
          "==「できる」ってどのくらいのレベルなんだろう==、それこそ実務で一通り作れるみたいなのを「できる」として考えてはいたんですけど。スクールさんが提供してくれてる「できますよ」の「できる」のゴールがどのレベルなんだろうって。コードをただただ書けるを「できる」としてるのか、本当に副業として少し小さめの案件取れるのが「できる」なのか、転職して即戦力として働いていけるを「できる」としてるのかみたいな==レベル感が分からなかった==のは、スクール選びで迷ったことかなと思います。",
      },
      {
        question:
          "他の学習サービスやスクールと比較して、なぜゆめさくエンジニアを選ばれたんですか？",
        answer:
          "カウンセリングを最初に行ってもらった時に、==「ただコードが書けるだけじゃ意味がないと思ってる」==って、そこで担当してくださった方がおっしゃってて。その時に、==自分の想像してる「できる」のレベルに近いのがここなのかな==っていうのを直感的に思ったので、ここに決めました。",
      },
      {
        question:
          "実際に受講してみて一番印象に残っていることはありますか？",
        answer:
          "最初から「コードを書きましょう」って進まなくて、18ヶ月やっていったらどのくらいのことができるんじゃないかみたいな、==その先を最初に見せてくれる==。でも単純に夢物語みたいな感じじゃなくて、==「こういうエンジニアはダメだけど、こういうエンジニアになってほしい」みたいな現実もちゃんと見せてくれ==ながらスタートしていくっていうカリキュラムになってる。自分もこの罠に陥ってたな、本当にこう言ってるリスクと今直面してるなみたいなのがあるので。==プログラミングやってましたっていう私が学べるところは多かった==ので、結構レベルが高いんじゃないかなっていうのは直感的に思いました。",
      },
      {
        question:
          "カリキュラムについて難しさや分かりやすさについてはどう感じていますか？",
        answer:
          "難しさは、私自身は感じてはいないです。入社の時にやってた研修とダブってしまって、ちょっと易しいなと思ってる部分もあるんですけど。==その研修と被ってるってことは、会社が求めてるものと一緒だ==っていうことだとは思うので。別の業界から転職したいみたいな人からすると、==ITの業界に踏み入れた時に役に立つスキルとか知識は学べていける==んじゃないかなとは思ってます。",
      },
      {
        question:
          "特に良かったコンテンツやサポートはありましたか？",
        answer:
          "運営さんの方でコラムみたいなのを掲載してくれてて、提供してくださってるポータルサイトの裏情報とかが知れるので。これが学んでいってどの段階でちゃんと理解して、どの段階で自分でも書けると思えるようになるのかっていう、一個の成長を見れる指数になるのかなっていうのを考えているので、そこがちょっと楽しみではあります。",
      },
      {
        question: "今後学んだスキルをどう活かしていきたいですか？",
        answer:
          "一旦副業で、フロント側をメインで作る、スクールで得たもの活かして。本業でバックエンド側の実装とか仕様書書いてるので、==どっちもできるような形にしてからフリーランスに行こうかな==っていうのを少しずつ考えるようになりました。入会前はフリーランスになれるぐらいの知識を得たいと思っていて。自分が罠に陥ってるな、リスクにはまりそうだなっていうのに当てはまってることに気づいたので、ちょっと方向転換も見つつ。==そういったところもちゃんと懸念とかも教えてもらえる==っていうのは、スクールに入ったからこそのメリットだと思ってます。",
      },
      {
        question:
          "これから始める人に一言メッセージをお願いいたします。",
        answer:
          "結構私もスクール選び悩んで不安かなとは思うんですけど、ここは割と==最初から最後まで意見を聞いてくれたり、「大丈夫？」みたいな声掛けはしてくれる==ので、続けていきやすいところかなとは思います。あとは==不安も多分口にすれば吸収してくれるぐらい近くにいてくれる存在==なので。有名どころとか大手さんとかも視野には入るとは思うんですけど、そこともいいところと悪いところって絶対あると思うんで、自分にとっていいところを見つけていってもらって、そこが合うか合わないかが一番大事なのかなと思います。",
      },
    ],
  },
  {
    slug: "asami-travel-engineer",
    title:
      "接客業から「旅するエンジニア」へ、理想の働き方を叶える第一歩｜あさみさん 27歳",
    excerpt:
      "接客業が好きだけど体力的な不安を抱えていたあさみさん。パソコンが苦手でも18ヶ月かけてじっくり学べる環境に惹かれ入会。趣味の写真をまとめるWebサイト制作に挑戦中。旅をしながらリモートで働く夢を追う。",
    date: "2026-03-11",
    profile: {
      name: "あさみさん",
      age: "27歳",
      background: "接客業",
    },
    videoId: "1163288065",
    noteId: "n49e7a43e9f24",
    takeaways: [
      "接客業の体力的な不安から、リモートワーク可能なスキルを求めて学習開始",
      "パソコンが苦手でも18ヶ月かけてじっくり学べるカリキュラムに安心感",
      "シフト制の仕事でも、アーカイブ視聴で自分のペースで学習できている",
      "趣味の写真をまとめるWebサイト制作に挑戦中、旅しながら働く夢を追う",
    ],
    content: [
      {
        question: "簡単に自己紹介をお願いいたします。",
        answer:
          "あさめと申します。普段は接客業をしていて……27歳です。趣味は旅行と写真を撮ることです。",
      },
      {
        question:
          "プログラミングやAIなどに興味を持ったのは、いつ頃、どんなきっかけですか？",
        answer:
          "ここ1〜2年くらい前からです。接客の仕事自体好きなんですけど、==体力的な不安==もあって。そんな時に友達がちょうどこういうお仕事をしていたので、どんな感じかなと思って興味を持ったのがきっかけです。",
      },
      {
        question: "入会前にどんなことで悩んでいましたか？",
        answer:
          "パソコン自体得意ではないので、何から手をつけていいか全く分からなかったんですけど。独学で始めようと思っても何をどの順番で始めればいいか分からなかったので、全てが分からないまま始まりました。",
      },
      {
        question:
          "他の学習サービスやスクールと比較して、なぜゆめさくエンジニアを選びましたか？",
        answer:
          "==18ヶ月かけてじっくり学べる==というところに惹かれて選びました。シフト制で働いているので、毎日決まった時間に勉強するのが難しくて。==自分のペースで進められる==かなと思って、長期間の魅力を感じてこちらにしました。",
      },
      {
        question:
          "実際に受講してみて一番印象に残っていることは何ですか？",
        answer:
          "週2で開催されてる勉強会ですかね。仕事で時間が不規則なので、もし勉強会に参加できなくても==アーカイブでしっかり後から自分で勉強することができる==のが、安心感があってとってもいいです。",
      },
      {
        question:
          "カリキュラムの難しさや分かりやすさについてはどう感じましたか？",
        answer:
          "専門用語ばっかりで最初分からないかなって思ってたんですけど、==すごい噛み砕いて説明してくれる==ので、難しいけどとっても分かりやすいです。",
      },
      {
        question:
          "特に良かったコンテンツやサポートはありましたか？",
        answer:
          "==講師の方々がレスポンスが早くて==、分からないことを質問するとすぐに回答が返ってくるので、とってもいいです。",
      },
      {
        question:
          "スキル面やマインド面で、入会前と比べてどんな変化がありましたか？",
        answer:
          "==分からないことを分からないままにしない、恐れなくなった==っていうのが一番の変化ですかね。",
      },
      {
        question:
          "ポートフォリオ作成、副業、転職などで何か動きはありましたか？",
        answer:
          "まだ始めたばかりなので、これができたとか完成したとかはないんですけど、一番やりたい自分の趣味の写真をウェブページにまとめるっていうのをちょっとずつ進めていけたらなと思ってます。",
      },
      {
        question:
          "どんな働き方やキャリアを目指されていますか？",
        answer:
          "ゆくゆくは==旅行をしながらリモートで働いていきたくて==。自由にどこでも行けて、どこでもできるよっていうのを叶えていきたいなと思っております。",
      },
      {
        question:
          "これから始める人に一言メッセージをお願いいたします。",
        answer:
          "プログラミングを学ぶ頃って色々あると思うんですけど、こちらは==女性専用ということもあって、自分と同じ環境や境遇の人と一緒に共に学べる==というところに安心感があるので、ぜひみんなで一緒に学べたらなって思っております。",
      },
    ],
  },
  {
    slug: "nabechan-mama-remote-work",
    title:
      "2児の母が目指す在宅エンジニア｜なべちゃんさん 30代 技術開発職",
    excerpt:
      "技術開発職で働く二児の母。産休・育休中にAI学習を始めたことがきっかけ。通勤片道40分の生活から在宅ワークへの転職を目指し、体系的なロードマップと素早いサポートに支えられながら学習中。",
    date: "2026-03-11",
    profile: {
      name: "なべちゃんさん",
      age: "30代",
      background: "会社員（技術開発）・二児の母",
    },
    videoId: "1164598984",
    takeaways: [
      "技術開発職で働く二児の母、産休中にAI学習を始めたのがきっかけ",
      "通勤片道40分の生活から在宅ワークへの転職を目指して学習中",
      "学習期間の長さと体系的なロードマップが入会の決め手",
      "質問へのレスポンスの速さとライブ授業のサポートを実感",
    ],
    content: [
      {
        question: "簡単に自己紹介をお願いいたします。",
        answer:
          "なべちゃんです。会社員で技術開発の仕事をしています。",
      },
      {
        question:
          "プログラミングやAIなどに興味を持ったのはいつ、どんなきっかけですか？",
        answer:
          "割と最近にはなるんですけれども、会社でAIを使う頻度が増えて。ちょうどその時が産休・育休中で、「何か勉強したいな」と思った時に、AIを自分でちょっと勉強してみようと思って勉強し始めたのがきっかけです。",
      },
      {
        question:
          "副業、転職、趣味など、学ぶ上でどんなことを理想としていますか？",
        answer:
          "子供が今2人いて、今は仕事で通勤が40分、片道でかかっているんですけれども。==転職して、できれば在宅でできたらいいな==と思ってます。",
      },
      {
        question: "入会前、どんなことで悩んでいましたか？",
        answer:
          "まず自分がプログラミングとかできるようになるのかっていうのと、実際に自分に合ってるのか。それでかつ、就職できたとしてもそこで活躍ができるのかっていうのが一番ネックになっていました。",
      },
      {
        question:
          "他の学習サービスやスクールと比較して、なぜゆめさくエンジニアを選ばれましたか？",
        answer:
          "==期間が長い==っていうのと、==ロードマップがしっかりしていて体系的に広い範囲で学べる==っていうのが大きいなと思ってます。",
      },
      {
        question:
          "実際に受講してみて一番印象に残っていることは何ですか？",
        answer:
          "==質問とかがすぐ返ってくる==っていうのが印象に残っています。",
      },
      {
        question:
          "カリキュラムの難しさや分かりやすさについてはどう感じていますか？",
        answer:
          "まだ知識の部分があるので、難しさとかいうのは特に感じてないです。でもすごいとても分かりやすくて、今学んでいる知識が最終的に技術を身につけた後に生きてくるんだろうなと感じてます。",
      },
      {
        question:
          "特に良かったコンテンツやサポートはありましたか？",
        answer:
          "Mattermost（マターモスト）での質問や、Zoomの動画を聴いてる最中にすぐ質問ができることが良かったです。",
      },
      {
        question:
          "スキル面やマインド面で、入会前と比べてどんな変化がありましたか？",
        answer:
          "まず==体系的に学べる==というところで、広い知識を身につけられることで実際に業務とかになった時に「あ、生きてくるんだろうな」という気になってきました。",
      },
      {
        question: "今後学んだスキルをどう活かしていきたいですか？",
        answer:
          "まずは今やってる仕事で業務の効率化とかができればなんかいいなと思ってて。それを元に、==最終的には在宅で仕事ができる職種に就けたらな==と思って今やっています。",
      },
      {
        question:
          "これから始める人に一言メッセージをお願いいたします。",
        answer:
          "一般的な知識から深いところまで学べるので、まず一歩やってみることがいいかなと思ってます。",
      },
    ],
  },
  {
    slug: "freelance-designer-challenge",
    title:
      "フリーランスデザイナーの挑戦 — デザイン経験を武器に、単価アップを目指す",
    excerpt:
      "LINE関係のデザイン業務でCSSに触れた楽しさをきっかけにプログラミング学習を開始。フロントエンドエンジニアとして案件単価を上げることを目標に、育児とフリーランス業を両立しながら学習中。",
    date: "2026-04-14",
    thumbnail: "/assets/voice_interview_07.webp",
    profile: {
      name: "受講生（匿名）",
      age: "—",
      background: "ママ・フリーランス（LINE関連デザイン）",
    },
    videoId: "1185117557",
    takeaways: [
      "LINEデザイン業務でCSSに触れた楽しさがきっかけ",
      "フロントエンドエンジニアとして案件単価を上げることが目標",
      "網羅的なカリキュラムと長いサポート期間が決め手",
      "週2回のZoom直接指導と早期の方向性決定が大きな変化",
    ],
    content: [
      {
        question: "簡単に自己紹介をお願いします。",
        answer:
          "子育てをしながら、フリーランスとして自宅で働いています。もともとはLINE関係のデザインなどの仕事をしていました。",
      },
      {
        question: "プログラミングに興味を持たれたきっかけを教えてください。",
        answer:
          "LINEのデザイン業務の中で==CSSを触る機会==があったのですが、それが楽しいと感じたんです。それをきっかけに、もっと深くプログラミングについても学んでいきたいと思うようになりました。",
      },
      {
        question: "学び方の理想や、今後の目標について教えてください。",
        answer:
          "すでにフリーランスとして活動しているので、プログラミングスキルを身につけることで==仕事の単価を上げていきたい==というのが一番の目標です。",
      },
      {
        question: "入会前はどんなことで悩んでいましたか？",
        answer:
          "プログラミングという枠はすごく広いので、その中で自分が何をやりたいのか、学んだ先にどのような働き方があるのかがはっきり分かっておらず、不安を感じていました。",
      },
      {
        question:
          "他のスクールも検討されたかと思いますが、なぜゆめさくエンジニアを選ばれたのでしょうか？",
        answer:
          "==講座内容が非常に網羅的==で、プログラミング全体を学べると感じたからです。また、==サポート期間が長く==設定されているので、忙しい時期があっても自分のペースで休みながら進められると思ったのが決め手でした。",
      },
      {
        question: "実際に受講してみて、印象に残っていることはありますか？",
        answer:
          "やはり講座のボリュームと、サポート面の幅広さには驚きました。初めて聞く内容で「難しいな」と感じることもありますが、==図を使って噛み砕いて説明==してくれるので、なんとかついていくことができています。",
      },
      {
        question: "特に良かったコンテンツやサポートはありますか？",
        answer:
          "==週に2回開催されるZoomでの直接指導==は、とても分かりやすくて助かっています。また、最初の方の講座で「プログラミングのどの道に進むべきか」という説明があり、==「自分はフロントエンドの道に進もう」と方向性が定まってきた==のが本当に良かったです。",
      },
      {
        question: "入会前と比べて、自分自身の変化は感じますか？",
        answer:
          "進むべき方向性がはっきりしてきたことで、==「ここを重点的に学ぼう」という意欲==が湧き、以前抱いていた不安がなくなりました。",
      },
      {
        question: "今後、学んだスキルをどのように活かしていきたいですか？",
        answer:
          "現状は、フロントエンドのエンジニアとして、フリーランスで案件を獲得していきたいと考えています。",
      },
      {
        question: "受講を検討している方へメッセージをお願いします。",
        answer:
          "ゆめさくエンジニアは、==Zoomでの講義、チャットコミュニティ、そしてメンターさんとの月1回の面談など、本当にサポートが手厚い==です。初心者の方でも安心して始められる環境が整っているので、ぜひおすすめしたいです！",
      },
    ],
  },
];

// ============================================================================
// ヘルパー関数
// ============================================================================

/** slug からインタビュー記事を取得 */
export function getInterviewBySlug(
  slug: string,
): VoiceInterview | undefined {
  return voiceInterviews.find((v) => v.slug === slug);
}

/** Vimeo ID から動画を取得 */
export function getVideoById(id: string): VoiceVideo | undefined {
  return voiceVideos.find((v) => v.id === id);
}

/** 指定 slug 以外のインタビュー記事を取得（最大 max 件） */
export function getOtherInterviews(
  currentSlug: string,
  max = 4,
): VoiceInterview[] {
  return voiceInterviews
    .filter((v) => v.slug !== currentSlug)
    .slice(0, max);
}

/** ターゲット別のインタビュー記事を取得 */
type TargetAudience =
  | "beginners"
  | "20s"
  | "30s"
  | "moms"
  | "workers"
  | "cs-students";

const audienceMap: Record<TargetAudience, string[]> = {
  beginners: [
    "asami-travel-engineer",
    "teacher-to-frontend-engineer",
    "miyazaki-freeter-to-engineer",
  ],
  "20s": [
    "asami-travel-engineer",
    "teacher-to-frontend-engineer",
    "it-engineer-freelance-fullstack",
    "miyazaki-freeter-to-engineer",
  ],
  "30s": ["nabechan-mama-remote-work"],
  moms: ["nabechan-mama-remote-work"],
  workers: [
    "nabechan-mama-remote-work",
    "it-engineer-freelance-fullstack",
    "asami-travel-engineer",
  ],
  "cs-students": ["it-engineer-freelance-fullstack"],
};

export function getInterviewsForAudience(
  audience: TargetAudience,
  max = 3,
): VoiceInterview[] {
  const slugs = audienceMap[audience] ?? [];
  return slugs
    .map((s) => voiceInterviews.find((v) => v.slug === s))
    .filter((v): v is VoiceInterview => v !== undefined)
    .slice(0, max);
}


/** 日付フォーマット */
export function formatVoiceDate(dateString: string): string {
  const date = new Date(dateString);
  // 書き出しの機械の時間帯で日がずれないよう、日本の日付で出す ("2026-03-20" は UTC の 0 時として読まれる)
  return date.toLocaleDateString("ja-JP", {
    timeZone: "Asia/Tokyo",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}
